import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Box
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
// import PhoneInput from "react-phone-input-2";
import { makeStyles } from "@mui/styles";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert, Row, Col, CardTitle, CardHeader } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import { Route, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { countries } from "../../utils/countriesDropdown";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import CustomButton from "../../components/CustomButton/CustomButton";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import CommonLogout from "../../components/CommonLogout/CommonLogout";
import {
	resetGetWalletOwnerList,
	getWalletOwnerList
} from "../../redux/actions/getWalletOwnerListAction";
// import LoadingSpinner from "./LoadingSpinner";
import {
	resetcreateOrUpdateWalletOwner,
	createOrUpdateWalletOwner
} from "../../redux/actions/createOrUpdateWalletOwnerAction";
import { deleteWalletOwner } from "../../redux/actions/deleteWalletOwner";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { getThemeList } from "../../redux/actions/getThemeListAction";
import FileBase64 from "../../components/Upload/UploadFile";
import Util from "../../validation/index";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SOLogout from "../../components/Logout/SOLogout";

import val from "../../getThemeDetails"

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const AdminCreateWalletOwner = () => {
	const classes = useStyles();
	const [walletOwnerName, setWalletOwnerName] = useState("");
	const [userName, setUserName] = useState("");
	const [email, setEmail] = useState("");
	const [mobile, setMobile] = useState("");
	const [address, setAddress] = useState("");
	const [country, setCountry] = useState("");
	const [secretKey, setSecretKey] = useState("");
	const [website, setWebsite] = useState("");
	const [organizationName, setOrganizationName] = useState("");
	const [contactPerson, setContactPerson] = useState("");
	const [walletOwnerHostURL, setWalletOwnerHostURL] = useState("");
	const [customerMerchantHostURL, setCustomerMerchantHostURL] = useState("");
	const [supportURL, setSupportURL] = useState("");
	const [companyLogoName, setCompanyLogoName] = useState("");
	const [uploadIcon, setUploadIcon] = useState("");
	const [applyPrepaidSignUp, setApplyPrepaidSignUp] = useState("Y");
	const [fraudCheckAllow, setFraudCheckAllow] = useState("Y");
	const [emailAllow, setEmailAllow] = useState("Y");
	const [smsAllow, setSmsAllow] = useState("Y");
	const [emailOTPSignUp, setEmailOTPSignUp] = useState("Y");
	const [smsOTPSignUp, setSmsOTPSignUp] = useState("Y");
	const [walletRequired, setWalletRequired] = useState("Y");
	const [voucherRequired, setVoucherRequired] = useState("N");
	const [twoFactorAuthen, setTwoFactorAuthen] = useState("N");
	const [fxSchedular , setfxSchedular]=useState('N');
	const [fxCronTime,setfxCronTime]=useState('0 0 10 * * ?');

	const [template, setTemplate] = useState("Y");
	const [currentTheme, setCurrentTheme] = useState("");
	const [expiryDays, setExpiryDays] = useState("");
	const [allowRefund, setAllowRefund] = useState("");
	const [isCustomAmtAllowed, setIsCustomAmtAllowed] = useState("");
	const [minVoucherAmt, setMinVoucherAmt] = useState("");

	const [companyLogoNameImg, setCompanyLogoNameImg] = useState("");
	const [uploadIconImg, setUploadIconImg] = useState("");

	const [invoiceRequired, setinvoiceRequired] = useState('Y');
	const [openBankingRequired, setopenBankingRequired] = useState('Y');

	const [twitterUrl, settwitterUrl] = useState('');
	const [instagramUrl, setinstagramUrl] = useState('');
	const [facebookUrl, setfacebookUrl] = useState('');

	//Consent (Transaction and Sign Up)
	const [getSignUpConsent, setGetSignUpConsent] = useState('');
	const [getTransactionConsent, setGetTransactionConsent] = useState('')

	const handleAttachmentsDoc = (e, companyLogo) => {
		if (companyLogo == "companyLogo") {
			setCompanyLogoNameImg(e.base64);
			setCompanyLogoName(e.name);
		} else if (companyLogo == "uploadIcon") {
			setUploadIconImg(e.base64.substring(e.base64.indexOf(',') + 1));
			setUploadIcon(e.name);
		}
	};

	const themeList = useSelector(({ getThemeList }) => getThemeList);

	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [getWalletOwnerListResArray, setgetWalletOwnerListResArray] = useState(
		[]
	);
	const [getBusinessNatureListStatus, setGetBusinessNatureListStatus] =
		useState(false);
	// const [logoutvalue, setLogoutvalue] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [open, setOpen] = React.useState(false);
	const [view, setView] = React.useState(false);
	const [deleteAcc, setDeleteAcc] = useState("");
	const [del, setDel] = useState(false);
	const [deleteOwnerWalletStatus, setDeleteOwnerWalletStatus] = useState(false);
	const [deleteOwnerWalletArray, setDeleteOwnerWalletArray] = useState([]);
	console.log(deleteOwnerWalletArray, "deleteOwnerWalletArray");
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [updateCustomerDetails, setUpdateCustomerDetails] = useState(false);
	const [updateCreateWalletResArray, setUpdateCreateWalletResArray] =
		useState("");
	const [operationId, setOperationId] = useState("");
	const [createWallet, setCreateWallet] = useState("");

	const [viewwalletOwnerName, setviewwalletOwnerName] = useState("");
	const [viewUserName, setviewUserName] = useState("");
	const [viewUserEmail, setviewUserEmail] = useState("");
	const [viewUserMobile, setviewUserMobile] = useState("");
	const [editwalletOwnerName, seteditwalletOwnerName] = useState("");
	const [editUserName, seteditUserName] = useState("");
	const [editUserEmail, seteditUserEmail] = useState("");
	const [editUserMobile, seteditUserMobile] = useState("");
	const [ownerId, setOwnerId] = useState("");

	const dispatch = useDispatch();

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;
	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getWalletOwnerListRes = useSelector(
		({ getWalletOwner }) => getWalletOwner
	);
	console.log(getWalletOwnerListRes);

	const deleteOwnerWalletRes = useSelector(
		({ deleteWalletOwner }) => deleteWalletOwner
	);

	const createOrUpdateWalletOwnerRes = useSelector(
		({ createOrUpdateWalletOwner }) => createOrUpdateWalletOwner
	);

	const getWalletOwnerListRequest = () => {
		setGetBusinessNatureListStatus(true);
		setIsLoading(true);
		const getAdminCreateWalletOwnerListReq = {
			ownerMasterRequestVO: {
				adminId: val.adminIDS,
				ownerName: walletOwnerName,
				userName: userName,
				email: email,
				mobile: mobile
			}
		};

		dispatch(getWalletOwnerList(getAdminCreateWalletOwnerListReq, authToken));
	};

	// Curent Theme
	const currentThemeRequest = () => {
		// setAddWalletStatus(true);

		const currentThemeReq = {
			loginDetails: {
				// adminId: "2"
				adminId: val.adminIDS
			}
		};
		dispatch(getThemeList(currentThemeReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			currentThemeRequest();
			getWalletOwnerListRequest();
		}
	}, [regenerateTokenRes.data.AuthToken]);

	const updateDetailsOwnerApi = (item) => {
		setOpen(false);
		setUpdateCustomerDetails(true);
		const updateOwnerDetailsReq = {
			loginDetails: {
				walletOwnerId: ownerId,
				// adminId: "2"
				adminId: val.adminIDS
			},
			ownerMasterRequestVO: {
				ownerName: editwalletOwnerName,
				userName: editUserName,
				email: editUserEmail,
				mobile: editUserMobile,
				address: address,
				country: country,
				secKey: secretKey,
				website: website,
				organization: organizationName,
				contactPerson: contactPerson,
				hostURL: customerMerchantHostURL,
				ownhostURL: walletOwnerHostURL,
				supportURL: supportURL,
				companyLogo: companyLogoNameImg,
				iconBase64: uploadIconImg,
				isPrepaidCard: applyPrepaidSignUp == "Y" ? "1" : "0",
				isFraudCheck: fraudCheckAllow == "Y" ? "1" : "0",
				isEmailAllowed: emailAllow == "Y" ? "1" : "0",
				isSMSAllowed: smsAllow == "Y" ? "1" : "0",
				isEmailOtp: emailOTPSignUp == "Y" ? "1" : "0",
				isSMSOtp: smsOTPSignUp == "Y" ? "1" : "0",
				isWallet: walletRequired == "Y" ? "Y" : "N",
				isVoucher: voucherRequired == "N" ? "N" : "Y",
				isTemplate: template == "Y" ? "1" : "0",
				currentTheme: currentTheme,
				expiryDays: expiryDays,
				allowRefund: allowRefund == "N" ? "N" : "Y",
				isCustomAmtAllowed: isCustomAmtAllowed == "N" ? "N" : "Y",
				minVoucherAmt: minVoucherAmt == "N" ? "N" : "Y",
				invoiceRequired: invoiceRequired,
				openBankingRequired: openBankingRequired,
				twitterUrl: twitterUrl,
				instagramUrl: instagramUrl,
				facebookUrl: facebookUrl,
				signupConsent: getSignUpConsent,
				transactionConsent: getTransactionConsent,
				twoFactorGoogle: twoFactorAuthen == "N" ? "N" : "Y",
				fxSchedular:fxSchedular== "N" ? "N" : "Y",
				fxCronTime:fxCronTime,
			}
		};
		dispatch(createOrUpdateWalletOwner(updateOwnerDetailsReq, authToken));
		setOperationId("");
		setCreateWallet("");
	};

	const updateDetailsOwnerApiFunc = () => {
		if (updateCustomerDetails) {
			if (createOrUpdateWalletOwnerRes.data.status == "success") {
				setUpdateCreateWalletResArray(createOrUpdateWalletOwnerRes.data);
				getWalletOwnerListRequest();
				setNotificationOpen(true);
			}
			if (createOrUpdateWalletOwnerRes.data.status == "failed") {
				setUpdateCreateWalletResArray(createOrUpdateWalletOwnerRes.data);
				setNotificationOpen(true);
				if (
					createOrUpdateWalletOwnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createOrUpdateWalletOwnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (createOrUpdateWalletOwnerRes.data.status == "Failed") {
				setUpdateCreateWalletResArray(createOrUpdateWalletOwnerRes.data);
				setNotificationOpen(true);
				if (
					createOrUpdateWalletOwnerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					createOrUpdateWalletOwnerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		if (createOrUpdateWalletOwnerRes.data.status == "success") {
			updateDetailsOwnerApiFunc();
		}
	}, [createOrUpdateWalletOwnerRes.data.status]);

	const deleteOwnwerWallet = () => {
		setDeleteOwnerWalletStatus(true);
		setDel(false);
		let req = {
			loginDetails: {
				// adminId: 2
				adminId: val.adminIDS

			},
			ownerMasterRequestVO: {
				ownerID: deleteAcc
			}
		};
		dispatch(deleteWalletOwner(req, authToken));
	};

	const deleteOwnerWalletResFunc = () => {
		if (deleteOwnerWalletStatus) {
			if (deleteOwnerWalletRes.data.status == "success") {
				console.log(deleteOwnerWalletRes, "deleteOwnerWalletRes");
				setDeleteOwnerWalletArray(deleteOwnerWalletRes.data);
				getWalletOwnerListRequest();
				setNotificationOpen(true);
			}
			if (deleteOwnerWalletRes.data.status == "failed") {
				setDeleteOwnerWalletArray(deleteOwnerWalletRes.data);
				setNotificationOpen(true);
				if (
					deleteOwnerWalletRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					deleteOwnerWalletRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		deleteOwnerWalletResFunc();
	}, [deleteOwnerWalletRes.data.status]);

	const deleteHandleClickOpen = (value) => {
		setDeleteAcc(value);
		setDel(true);
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setOpen(false);
		setView(false);
		setDel(false);
	};

	const updateDetailsOwner = () => {
		updateDetailsOwnerApi();
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "walletOwnerName") {
			// setWalletOwnerName(value);
			Util.verifyAlphabet(value)
				? setWalletOwnerName(value)
				: setWalletOwnerName(walletOwnerName);
		}
		if (name === "userName") {
			// setUserName(value);
			Util.verifyAlphabet(value) ? setUserName(value) : setUserName(userName);
		}
		if (name === "email") {
			setEmail(value);
		}
		if (name === "mobile") {
			// setMobile(value);
			Util.verifyMobile(value) ? setMobile(value) : setMobile(mobile);
		}
		if (name === "address") {
			setAddress(value);
		}
		if (name === "country") {
			setCountry(value);
		}
		if (name === "secretKey") {
			setSecretKey(value);
		}
		if (name === "website") {
			setWebsite(value);
		}
		if (name === "organizationName") {
			// setOrganizationName(value);
			Util.verifyAlphabet(value)
				? setOrganizationName(value)
				: setOrganizationName(organizationName);
		}
		if (name === "contactPerson") {
			// setContactPerson(value);
			Util.verifyAlphabet(value)
				? setContactPerson(value)
				: setContactPerson(contactPerson);
		}
		if (name === "walletOwnerHostURL") {
			setWalletOwnerHostURL(value);
		}
		if (name === "customerMerchantHostURL") {
			setCustomerMerchantHostURL(value);
		}
		if (name === "supportURL") {
			setSupportURL(value);
		}
		if (name === "companyLogoName") {
			setCompanyLogoName(value);
		}
		if (name === "uploadIcon") {
			setUploadIcon(value);
		}
		if (name === "applyPrepaidSignUp") {
			setApplyPrepaidSignUp(value);
		}

		if (name === "fraudCheckAllow") {
			setFraudCheckAllow(value);
		}
		if (name === "emailAllow") {
			setEmailAllow(value);
		}
		if (name === "smsAllow") {
			setSmsAllow(value);
		}
		if (name === "emailOTPSignUp") {
			setEmailOTPSignUp(value);
		}
		if (name === "smsOTPSignUp") {
			setSmsOTPSignUp(value);
		}

		if (name === "walletRequired") {
			setWalletRequired(value);
		}
		if (name === "voucherRequired") {
			setVoucherRequired(value);
		}
		if (name === "twoFactorAuthen") {
			setTwoFactorAuthen(value);
		}
		if (name === "template") {
			setTemplate(value);
		}
		if (name === "currentTheme") {
			setCurrentTheme(value);
		}
		if (name === "editwalletOwnerName") {
			// seteditwalletOwnerName(value);
			Util.verifyAlphabet(value)
				? seteditwalletOwnerName(value)
				: seteditwalletOwnerName(editwalletOwnerName);
		}
		if (name === "editUserName") {
			// seteditUserName(value);
			Util.verifyAlphabet(value)
				? seteditUserName(value)
				: seteditUserName(editUserName);
		}
		if (name === "editUserEmail") {
			seteditUserEmail(value);
		}
		if (name === "editUserMobile") {
			// seteditUserMobile(value);
			Util.verifyMobile(value)
				? seteditUserMobile(value)
				: seteditUserMobile(editUserMobile);
		}
		if (name === "expiryDays") {
			// setExpiryDays(value);
			Util.verifyNumber(value)
				? setExpiryDays(value)
				: setExpiryDays(editUserMobile);
		}
		if (name === "allowRefund") {
			setAllowRefund(value);
		}
		if (name === "isCustomAmtAllowed") {
			setIsCustomAmtAllowed(value);
		}
		if (name === "minVoucherAmt") {
			setMinVoucherAmt(value);
		}

		if (name === 'invoiceRequired') {
			setinvoiceRequired(value)
		}
		if (name === 'openBankingRequired') {
			setopenBankingRequired(value)
		}
		if (name === 'twitterUrl') {
			settwitterUrl(value);
		}
		if (name === 'instagramUrl') {
			setinstagramUrl(value);
		}
		if (name === 'facebookUrl') {
			setfacebookUrl(value);
		}
		//Consent (Sign up and Transaction)
		if (name === 'getSignUpConsent') {
			setGetSignUpConsent(value);
		}
		if (name === 'getTransactionConsent') {
			setGetTransactionConsent(value);
		}
		if(name==='fxSchedular'){
			setfxSchedular(value);
		}
		if(name==='fxCronTime'){
			setfxCronTime(value);
		}
	};

	const views = "views";
	const edit = "edit";

	const updateHandleClickOpen = (walletOwnerId, countries, fs) => {
		getWalletOwnerListResArray.map((item) => {
			if (item.ownerId == walletOwnerId) {
				setOwnerId(item.ownerId);
				fs == "views"
					? setviewwalletOwnerName(item.ownerName)
					: setviewwalletOwnerName("");
				fs == "views" ? setviewUserName(item.userName) : setviewUserName("");
				fs == "views" ? setviewUserEmail(item.email) : setviewUserEmail("");
				fs == "views" ? setviewUserMobile(item.phone) : setviewUserMobile("");
				fs == "edit"
					? seteditwalletOwnerName(item.ownerName)
					: seteditwalletOwnerName("");
				fs == "edit" ? seteditUserName(item.userName) : seteditUserName("");
				fs == "edit" ? seteditUserEmail(item.email) : seteditUserEmail("");
				fs == "edit" ? seteditUserMobile(item.phone) : seteditUserMobile("");
				// setUserName(item.userName)
				// setEmail(item.email)
				// setMobile(item.phone)
				setAddress(item.address);
				countries.map((value) => {
					if (value.dial_code.split("-")[1] == item.countryCode) {
						setCountry(value.label + value.dial_code);
					}
				});
				setinvoiceRequired(item.invoiceRequired);
				setopenBankingRequired(item.openBankingRequired);
				setCountry(item.country);
				setSecretKey(item.secKey);
				setWebsite(item.website);
				setOrganizationName(item.organizationName);
				setContactPerson(item.contactPerson);
				setWalletOwnerHostURL(item.ownhostURL);
				setCustomerMerchantHostURL(item.hostURL);
				setSupportURL(item.supportURL);
				setCompanyLogoName("");
				// setCompanyLogoName(item.companyLogo);
				// setUploadIcon(item.iconBase64);
				setUploadIcon("");
				setApplyPrepaidSignUp(item.isPrepaidCard == "1" ? "Y" : "N");
				setFraudCheckAllow(item.isFraudCheck == "1" ? "Y" : "N");
				setEmailAllow(item.isEmailAllowed == "1" ? "Y" : "N");
				setSmsAllow(item.isSMSAllowed == "1" ? "Y" : "N");
				setEmailOTPSignUp(item.isEmailOtp == "1" ? "Y" : "N");
				setSmsOTPSignUp(item.isSMSOtp == "1" ? "Y" : "N");
				setWalletRequired(item.isWallet);
				setVoucherRequired(item.isVoucher);
				setTwoFactorAuthen(item.twoFactorGoogle);
				setTemplate(item.isTemplate);
				setCurrentTheme(item.currentTheme);
				setExpiryDays(item.expiryDays);
				setAllowRefund(item.allowRefund == "1" ? "Y" : "N");
				setIsCustomAmtAllowed(item.isCustomAmtAllowed == "1" ? "Y" : "N");
				setMinVoucherAmt(item.minVoucherAmt == "1" ? "Y" : "N");
				settwitterUrl(item.twitterUrl);
				setinstagramUrl(item.instagramUrl);
				setfacebookUrl(item.facebookUrl);
				setUploadIconImg(item.iconBase64);
				setGetSignUpConsent(item.signupConsent);
				setGetTransactionConsent(item.transactionConsent)
				// allowRefund: allowRefund == "N" ? "N" : "Y",
				// isCustomAmtAllowed: isCustomAmtAllowed == "N" ? "N" : "Y",
				// minVoucherAmt: minVoucherAmt == "N" ? "N" : "Y"
			}
		});
		console.log(getWalletOwnerListResArray, "This is it");
		if (fs == "views") {
			setView(true);
		}
		if (fs == "edit") {
			setOpen(true);
		}
	};

	const getWalletOwnerListResFunc = () => {
		if (getBusinessNatureListStatus) {
			if (getWalletOwnerListRes.data.status == "success") {
				setIsLoading(false);
				// setOpen(false);
				setgetWalletOwnerListResArray(
					[].concat(getWalletOwnerListRes.data.walletOwnerList)
				);
			}
			if (getWalletOwnerListRes.data.status == "Failed") {
				setIsLoading(false);
				setgetWalletOwnerListResArray(getWalletOwnerListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getWalletOwnerListRes.data.description
				);
				if (
					getWalletOwnerListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getWalletOwnerListRes.data.status == "failed") {
				setIsLoading(false);
				setgetWalletOwnerListResArray(getWalletOwnerListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getWalletOwnerListRes.data.description
				);
				setOpen(false);
				// setLogoutvalue(true);
				if (
					getWalletOwnerListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getWalletOwnerListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getWalletOwnerListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetWalletOwnerListResArray(getWalletOwnerListRes.data);
				NotificationPopups(
					"error",
					"Failed",
					getWalletOwnerListRes.data.description
				);
				// setLogoutvalue(true);
			}
		}
	};

	useEffect(() => {
		// if (getBusinessNatureListStatus) {
		getWalletOwnerListResFunc();
		// }
	}, [getWalletOwnerListRes.data.status]);

	// useEffect(() => {
	//   getWalletOwnerListRequest();
	//   console.log(getWalletOwnerListRequest)
	// }, [])

	const handleNoticationClose = () => {
		setNotificationOpen(false);
		// createWallet("");
	};

	return (
		<>
			<Layout>
				<Card>
					<Grid
						container
						style={{ padding: "25px", justifyContent: "right" }}
						spacing={2}
					>
						<Grid item md={2} sm={12} xs={12} lg={2}>
							<NavLink to="/index/add-wallet-owner">
								{/* <Button
									size="small"
									style={{
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									className="riskRuleButton"
								>
									Add Owner
								</Button> */}
								<CustomButton
									style={{
										padding: "8px",
										marginLeft: "15px"
									}}
								// onClick={getgateWayTransactionListReq}
								>
									Add owner
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								label="Owner Name"
								type="text"
								fullWidth
								variant="standard"
								value={walletOwnerName || ""}
								name="walletOwnerName"
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								label="User Name"
								type="text"
								fullWidth
								variant="standard"

								name="userName"
								value={userName || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								label="Email"
								type="text"
								fullWidth
								name="email"
								variant="standard"

								value={email || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								label="Mobile"
								type="text"
								fullWidth
								name="mobile"
								variant="standard"

								value={mobile || ""}
								onChange={handleChange}
								InputProps={{
									sx: {
										"&:before": { borderBottomColor: "gray" }, // before focus
										"&:after": { borderBottomColor: "gray" },  // after focus
									},
								}}
								InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								}}
							/>
						</Grid>

						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "17px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getWalletOwnerListRequest}
							>
								Search
							</Button> */}

							<CustomButton
								style={{
									padding: "8px",
									marginLeft: "15px"
								}}
								onClick={getWalletOwnerListRequest}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				<>
					{/* <CardTitle
            style={{
              marginBottom: "2px",
              textShadow: "none",
              fontSize: "20px",
            }}
           /> */}

					{isLoading ? (
						<LoadingSpinner />
					) : getWalletOwnerListResArray.length == undefined ||
						!getBusinessNatureListStatus ? (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}
										className="themeText"

									>
										Owner Master Details
									</Typography>
								</Grid>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Alert className="my-3 tableHeaderColor" variant="secondary">
										No Records Found!
									</Alert>
								</Grid>
							</Grid>
						</Card>
					) : (
						<Card>
							<Grid
								container
								style={{
									padding: "10px"
								}}
							>
								<Grid xs={12} sm={12} md={12} lg={12}>
									<Typography variant="body1" style={{ fontWeight: "700" }}
										className="themeText"

									>
										Owner Master Details
									</Typography>
								</Grid>
								<TableContainer component={Paper} className="my-3">
									<Table
										className={classes.table}
										style={{ padding: "6px 20px 6px 16px !important" }}
										size="small"
										aria-label="a dense table"
									>
										<TableHead>
											<TableRow className="tableHeaderColor">
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Owner ID
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Owner Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Email
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													UserName
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Mobile
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Organization Name
												</TableCell>
												<TableCell
													align="center"
													style={{ fontWeight: "bold", color: "white" }}
												>
													Action
												</TableCell>
												{/* <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Update
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontWeight: "bold", color: "white" }}
                    >
                      Delete
                    </TableCell> */}
											</TableRow>
										</TableHead>
										<TableBody>
											{getWalletOwnerListResArray &&
												[]
													.concat(getWalletOwnerListResArray)
													.slice(
														page * rowsPerPage,
														page * rowsPerPage + rowsPerPage
													)
													.map((row, index) => (
														<TableRow key={index}>
															<TableCell align="center">
																{row.ownerId}
															</TableCell>
															<TableCell align="center">
																{row.ownerName}
															</TableCell>
															<TableCell align="center">{row.email}</TableCell>
															<TableCell align="center">
																{row.userName}
															</TableCell>
															<TableCell align="center">{row.phone}</TableCell>
															<TableCell align="center">
																{row.organizationName}
															</TableCell>
															<TableCell
																align="center"
																style={{ display: "flex" }}
															>
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		updateHandleClickOpen(
																			row.ownerId,
																			countries,
																			views
																		)
																	}
																>
																	{
																		<VisibilityIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		updateHandleClickOpen(
																			row.ownerId,
																			countries,
																			edit
																		)
																	}
																>
																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	// onClick={() => deleteHandleClickOpen(row)}
																	onClick={() =>
																		deleteHandleClickOpen(row.ownerId)
																	}
																>
																	{
																		<DeleteIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</TableCell>
															{/* <TableCell align="center">
                            
                          </TableCell>
                          <TableCell align="center">
                            
                          </TableCell> */}
														</TableRow>
													))}
										</TableBody>
									</Table>
									<TablePagination
										rowsPerPageOptions={[5, 10, 25]}
										component="div"
										count={getWalletOwnerListResArray.length}
										rowsPerPage={rowsPerPage}
										page={page}
										onPageChange={handleChangePage}
										onRowsPerPageChange={handleChangeRowsPerPage}
									/>
								</TableContainer>
							</Grid>
						</Card>
					)}
					<div>
						<Dialog open={del} onClose={handleClose}>
							<DialogTitle style={{ width: "400px" }}>
								Are you sure?
							</DialogTitle>
							<DialogActions className="p-3">
								<Button
									style={{
										backgroundColor: "#fff",
										color: "#000"
									}}
									variant="contained"
									onClick={handleClose}
								>
									Cancel
								</Button>
								<Button
									style={{
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={deleteOwnwerWallet}
								>
									Yes
								</Button>
							</DialogActions>
						</Dialog>
					</div>

					<div>
						<Dialog open={open} onClose={handleClose}>
							<DialogTitle>Edit Customer</DialogTitle>
							<DialogContent>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Owner Name"
									type="text"
									fullWidth
									variant="standard"
									name="editwalletOwnerName"
									value={editwalletOwnerName || ""}
									required
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="User Name"
									type="text"
									fullWidth
									variant="standard"
									value={editUserName || ""}
									name="editUserName"
									required
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Email"
									type="text"
									fullWidth
									variant="standard"
									value={editUserEmail || ""}
									name="editUserEmail"
									required
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Mobile"
									type="text"
									fullWidth
									variant="standard"
									value={editUserMobile || ""}
									name="editUserMobile"
									required
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Address"
									type="name"
									fullWidth
									variant="standard"
									value={address || ""}
									name="address"
									required
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Country"
									type="name"
									fullWidth
									variant="standard"
									value={country || ""}
									name="country"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Website"
									type="name"
									fullWidth
									variant="standard"
									name="website"
									value={website || ""}
									required
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Organization Name"
									type="name"
									fullWidth
									variant="standard"
									value={organizationName || ""}
									name="organizationName"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Contact Person"
									type="name"
									fullWidth
									variant="standard"
									value={contactPerson || ""}
									name="contactPerson"
									required
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Owner Host URL"
									type="name"
									fullWidth
									variant="standard"
									value={walletOwnerHostURL || ""}
									name="walletOwnerHostURL"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Customer/Merchant Host URL"
									type="name"
									fullWidth
									variant="standard"
									value={customerMerchantHostURL || ""}
									name="customerMerchantHostURL"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Support URL"
									type="name"
									fullWidth
									variant="standard"
									value={supportURL || ""}
									name="supportURL"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								{/* <TextField
									autoFocus
									margin="dense"
									id="name"
									label="Company Logo Name"
									type="name"
									fullWidth
									variant="standard"
									value={companyLogoName || ""}
									name="companyLogoName"
									onChange={handleChange}
								/> */}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Company Logo Name
								</Typography>
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "companyLogo")}
									showUploadList={false}
									value={companyLogoNameImg}
								/>
								{companyLogoName ? companyLogoName : ""}
								<Typography
									variant="body1"
									align="justify"
									gutterBottom={true}
									style={{ color: "#4f6c8d" }}
								>
									Upload Icon
								</Typography>
								<FileBase64
									multiple={false}
									name={false}
									id="documentGuard1"
									accept=".jpeg, .png, .jpg, .pdf, .csv, .xls, .xlsx"
									onDone={(e) => handleAttachmentsDoc(e, "uploadIcon")}
									showUploadList={false}
									value={uploadIconImg || ''}
								/>
								{uploadIcon ? uploadIcon : ""}
								{/* <TextField
									autoFocus
									margin="dense"
									id="name"
									label="Upload Icon"
									type="name"
									fullWidth
									variant="standard"
									value={uploadIcon || ""}
									name="uploadIcon"
									onChange={handleChange}
								/> */}
								<TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Applying Prepaid Card During SignUp"
									type="name"
									fullWidth
									variant="standard"
									// value={
									// 	applyPrepaidSignUp ||
									// 	"Select Applying Prepaid Card During SignUp"
									// }
									defaultValue={"" || applyPrepaidSignUp}
									onChange={handleChange}
									name="applyPrepaidSignUp"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">
										Select Applying Prepaid Card During SignUp
									</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="Fraud Check Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={fraudCheckAllow || ""}
									defaultValue={"" || fraudCheckAllow}
									onChange={handleChange}
									name="fraudCheckAllow"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">Select Fraud Check Allowed</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="Email Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={emailAllow || "Select Email Allowed"}
									defaultValue={"" || emailAllow}
									onChange={handleChange}
									name="emailAllow"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">Select Email Allowed</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="SMS Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={smsAllow || "Select SMS Allowed"}
									defaultValue={"" || smsAllow}
									onChange={handleChange}
									name="smsAllow"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">Select SMS Allowed</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="Email OTP during Signup Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={
									// 	emailOTPSignUp || "Select Email OTP during Signup Allowed"
									// }
									defaultValue={"" || emailOTPSignUp}
									onChange={handleChange}
									name="emailOTPSignUp"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">
										Select Email OTP during Signup Allowed
									</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="SMS OTP during Signup Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={smsOTPSignUp || "Select SMS OTP during Signup Allowed"}
									defaultValue={"" || smsOTPSignUp}
									onChange={handleChange}
									name="smsOTPSignUp"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">
										Select SMS OTP during Signup Allowed
									</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="Wallet Required"
									type="name"
									fullWidth
									variant="standard"
									// value={walletRequired || "Wallet Required"}
									defaultValue={"" || walletRequired}
									onChange={handleChange}
									name="walletRequired"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">Wallet Required</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="Voucher Required"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									defaultValue={"" || voucherRequired}
									onChange={handleChange}
									name="voucherRequired"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">Select Voucher Required</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="Two Factor Google Authenticator"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									defaultValue={"" || twoFactorAuthen}
									onChange={handleChange}
									name="twoFactorAuthen"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">Select 2FA Required</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="Enable FX Scheduler"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									defaultValue={"" || fxSchedular}
									onChange={handleChange}
									name="fxSchedular"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">Enable Fxscheduler</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									margin="dense"
									id="name"
									label="FX Cron Expression"
									type="name"
									fullWidth
									variant="standard"
									value={fxCronTime || ""}
									name="fxCronTime"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<div>
									{voucherRequired == "Y" ? (
										<>
											<TextField
												size="small"
												color="primary"
												// autoFocus={true}
												label="Voucher Expiry Days"
												variant="standard"
												fullWidth={true}
												name="expiryDays"
												value={expiryDays || ""}
												// onChange={(e) => onInputChange(e)}
												onChange={handleChange}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											/>
											<TextField
												select
												margin="dense"
												id="name"
												label="Allow Refund"
												type="name"
												fullWidth
												variant="standard"
												// value={voucherRequired || "Select Voucher Required"}
												defaultValue={"" || allowRefund}
												name="allowRefund"
												onChange={handleChange}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											>
												<MenuItem value="">Select Allow Refund</MenuItem>
												<MenuItem value="Y">Y</MenuItem>
												<MenuItem value="N">N</MenuItem>
											</TextField>
											<TextField
												select
												margin="dense"
												id="name"
												label="Custom Amount Allowed"
												type="name"
												fullWidth
												variant="standard"
												// value={voucherRequired || "Select Voucher Required"}
												defaultValue={"" || isCustomAmtAllowed}
												name="customAmountAllowed"
												onChange={handleChange}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											>
												{/* <MenuItem value="Select Voucher Required">
												Select Voucher Required
											</MenuItem> */}
												<MenuItem value="">
													Select Custom Amount Allowed
												</MenuItem>
												<MenuItem value="Y">Y</MenuItem>
												<MenuItem value="N">N</MenuItem>
											</TextField>
											<TextField
												disabled
												margin="dense"
												id="name"
												label="Minimum Voucher Amount"
												type="name"
												fullWidth
												variant="standard"
												// value={voucherRequired || "Select Voucher Required"}
												defaultValue={"" || minVoucherAmt}
												name="minimumVoucherAmount"
												onChange={handleChange}
												InputProps={{
													sx: {
														"&:before": { borderBottomColor: "gray" }, // before focus
														"&:after": { borderBottomColor: "gray" },  // after focus
													},
												}}
												InputLabelProps={{
													sx: { color: 'gray' }, // Optional: if you want the label to be white
												}}
											>
												{/* <MenuItem value="Select Voucher Required">
												Select Voucher Required
											</MenuItem> */}
												<MenuItem value="">
													Select Minimum Voucher Amount
												</MenuItem>
												<MenuItem value="Y">Y</MenuItem>
												<MenuItem value="N">N</MenuItem>
											</TextField>
										</>
									) : (
										""
									)}
								</div>
								<TextField
									select
									margin="dense"
									id="name"
									label="Template"
									type="name"
									fullWidth
									variant="standard"
									// value={template || ""}
									defaultValue={"" || template}
									name="template"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">Select Template</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="Select Theme"
									type="name"
									fullWidth
									variant="standard"
									value={currentTheme || "Select Theme"}
									name="currentTheme"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="Select Theme">Select Theme</MenuItem>
									{themeList.data.themeList &&
										themeList.data.themeList.map((x) => (
											<MenuItem value={x}>{x}</MenuItem>
										))}
								</TextField>
								<TextField
									select
									margin="dense"
									id="name"
									label="Invoice Required"
									type="name"
									fullWidth
									variant="standard"
									// value={template || ""}
									defaultValue={"" || invoiceRequired}
									name="invoiceRequired"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									margin="dense"
									id="openBankingRequired"
									label="Open Banking Required"
									type="name"
									fullWidth
									variant="standard"
									// value={template || ""}
									defaultValue={"" || openBankingRequired}
									name="openBankingRequired"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									margin="dense"
									id="name"
									label="Twitter URL"
									type="name"
									fullWidth
									variant="standard"
									value={twitterUrl || ""}
									name="twitterUrl"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									margin="dense"
									id="name"
									label="Instagram URL"
									type="name"
									fullWidth
									variant="standard"
									value={instagramUrl || ""}
									name="instagramUrl"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									margin="dense"
									id="name"
									label="Facebook URL"
									type="name"
									fullWidth
									variant="standard"
									value={facebookUrl || ""}
									name="facebookUrl"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>

								<Box style={{ marginTop: "12px" }}>
									<Typography>Sign Up Consent</Typography>
									<textarea id="w3review" rows="5" cols="68"
										className="textAreaField"
										name="getSignUpConsent"
										value={getSignUpConsent || ""}
										onChange={handleChange}




									>

									</textarea></Box>
								<Box style={{ marginTop: "12px" }}>
									<Typography>Transaction Consent</Typography>
									<textarea id="w3review" rows="5" cols="68"
										className="textAreaField"
										type="text"
										name="getTransactionConsent"
										value={getTransactionConsent || ""}
										onChange={handleChange}


									>



									</textarea></Box>

							</DialogContent>
							<DialogActions style={{ padding: "14px" }}>
								<Button
									style={{
										backgroundColor: "#fff",
										color: "#000"
									}}
									variant="contained"
									onClick={handleClose}
								>
									Cancel
								</Button>
								<Button
									style={{
										backgroundColor: "#00b9f5",
										color: "white"
									}}
									variant="contained"
									onClick={updateDetailsOwner}
								>
									Save
								</Button>
							</DialogActions>
						</Dialog>
					</div>
					<div>
						<Dialog open={view} onClose={handleClose}>
							<DialogTitle>View Customer</DialogTitle>
							<DialogContent>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Owner ID"
									type="name"
									fullWidth
									variant="standard"
									value={ownerId || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Owner Name"
									type="name"
									fullWidth
									variant="standard"
									value={viewwalletOwnerName || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="User Name"
									type="name"
									fullWidth
									variant="standard"
									value={viewUserName || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Email"
									type="name"
									fullWidth
									variant="standard"
									value={viewUserEmail || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Mobile"
									type="name"
									fullWidth
									variant="standard"
									value={viewUserMobile || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Address"
									type="name"
									fullWidth
									variant="standard"
									value={address || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									autoFocus
									margin="dense"
									id="name"
									label="Country"
									type="name"
									fullWidth
									variant="standard"
									value={country || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									name="secretKey"
									label="Secret-key"
									type="name"
									fullWidth
									variant="standard"
									value={secretKey || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									label="Website"
									type="name"
									fullWidth
									variant="standard"
									value={website || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									label="Organization Name"
									type="name"
									fullWidth
									variant="standard"
									value={organizationName || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									label="Contact Person"
									type="name"
									fullWidth
									variant="standard"
									value={contactPerson || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									label="Owner Host URL"
									type="name"
									fullWidth
									variant="standard"
									value={walletOwnerHostURL || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									label="Customer/Merchant Host URL"
									type="name"
									fullWidth
									variant="standard"
									value={customerMerchantHostURL || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									label="Support URL"
									type="name"
									fullWidth
									variant="standard"
									value={supportURL || ""}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								{/* <TextField
									autoFocus
									margin="dense"
									id="name"
									label="Company Logo Name"
									type="name"
									fullWidth
									variant="standard"
									value={companyLogoName || ""}
									disabled={true}
								/> */}
								{/* <TextField
									autoFocus
									margin="dense"
									id="name"
									label="Upload Icon"
									type="name"
									fullWidth
									variant="standard"
									value={uploadIcon || ""}
									disabled={true}
								/> */}
								<TextField
									select
									// autoFocus
									margin="dense"
									id="name"
									label="Prepaid Card Feature Required"
									type="name"
									fullWidth
									variant="standard"
									// value={
									// 	applyPrepaidSignUp ||
									// 	"Select Applying Prepaid Card During SignUp"
									// }
									defaultValue={applyPrepaidSignUp}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									{/* <MenuItem value="1">
										Select Applying Prepaid Card During SignUp
									</MenuItem> */}
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									// autoFocus
									margin="dense"
									id="name"
									label="Fraud Check Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={fraudCheckAllow || ""}
									defaultValue={fraudCheckAllow}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									// autoFocus
									margin="dense"
									id="name"
									label="Email Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={emailAllow || "Select Email Allowed"}
									defaultValue={emailAllow}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									{/* <MenuItem value="1">Select Email Allowed</MenuItem> */}
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									// autoFocus
									margin="dense"
									id="name"
									label="SMS Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={smsAllow || "Select SMS Allowed"}
									defaultValue={smsAllow}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									{/* <MenuItem value="1">Select SMS Allowed</MenuItem> */}
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									// autoFocus
									margin="dense"
									id="name"
									label="Email OTP during Signup Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={
									// 	emailOTPSignUp || "Select Email OTP during Signup Allowed"
									// }
									defaultValue={emailOTPSignUp}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									{/* <MenuItem value="1">
										Select Email OTP during Signup Allowed
									</MenuItem> */}
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									// autoFocus
									margin="dense"
									id="name"
									label="SMS OTP during Signup Allowed"
									type="name"
									fullWidth
									variant="standard"
									// value={smsOTPSignUp || "Select SMS OTP during Signup Allowed"}
									defaultValue={smsOTPSignUp}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									{/* <MenuItem value="1">
										Select SMS OTP during Signup Allowed
									</MenuItem> */}
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									// autoFocus
									margin="dense"
									id="name"
									label="Invoice Required"
									type="name"
									fullWidth
									variant="standard"
									defaultValue={invoiceRequired}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									select
									// autoFocus
									margin="dense"
									id="name"
									label="Open Banking Required"
									type="name"
									fullWidth
									variant="standard"
									defaultValue={openBankingRequired}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
										<TextField
									select
									margin="dense"
									disabled
									id="name"
									label="Enable FX Scheduler"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									defaultValue={"" || fxSchedular}
									onChange={handleChange}
									name="fxSchedular"
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								>
									<MenuItem value="">Enable Fxscheduler</MenuItem>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField>
								<TextField
									margin="dense"
									id="name"
									disabled
									label="FX Cron Expression"
									type="name"
									fullWidth
									variant="standard"
									value={fxCronTime || ""}
									name="fxCronTime"
									onChange={handleChange}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									label="Twitter URL"
									type="name"
									fullWidth
									variant="standard"
									value={twitterUrl || "-"}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									label="Instagram URL"
									type="name"
									fullWidth
									variant="standard"
									value={instagramUrl || "-"}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<TextField
									// autoFocus
									margin="dense"
									id="name"
									label="Facebook URL"
									type="name"
									fullWidth
									variant="standard"
									value={facebookUrl || "-"}
									disabled={true}
									InputProps={{
										sx: {
											"&:before": { borderBottomColor: "gray" }, // before focus
											"&:after": { borderBottomColor: "gray" },  // after focus
										},
									}}
									InputLabelProps={{
										sx: { color: 'gray' }, // Optional: if you want the label to be white
									}}
								/>
								<Box style={{ marginTop: "12px" }}>
									<Typography>Sign Up Consent</Typography>
									<textarea id="w3review" rows="5" cols="68"
										className="textAreaField"
										name="getSignUpConsent"
										value={getSignUpConsent || ""}
										onChange={handleChange}
										disabled={true}



									>

									</textarea></Box>
								<Box style={{ marginTop: "12px" }}>
									<Typography>Transaction Consent</Typography>
									<textarea id="w3review" rows="5" cols="68"
										className="textAreaField"
										type="text"
										name="getTransactionConsent"
										value={getTransactionConsent || ""}
										onChange={handleChange}
										disabled={true}

									>



									</textarea></Box>
								{/* <TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Wallet Required"
									type="name"
									fullWidth
									variant="standard"
									defaultValue={walletRequired}
									disabled={true}
								>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField> */}
								{/* <TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Voucher Required"
									type="name"
									fullWidth
									variant="standard"
									// value={voucherRequired || "Select Voucher Required"}
									defaultValue={voucherRequired}
									disabled={true}
								>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField> */}
								{/* <TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Template"
									type="name"
									fullWidth
									variant="standard"
									// value={template || ""}
									defaultValue={template}
									disabled={true}
								>
									<MenuItem value="Y">Y</MenuItem>
									<MenuItem value="N">N</MenuItem>
								</TextField> */}
								{/* <TextField
									select
									autoFocus
									margin="dense"
									id="name"
									label="Select Theme"
									type="name"
									fullWidth
									variant="standard"
									value={currentTheme || "Select Theme"}
									disabled={true}
								>
									<MenuItem value="Select Theme">Select Theme</MenuItem>
									{themeList.data.themeList &&
										themeList.data.themeList.map((x) => (
											<MenuItem value={x}>{x}</MenuItem>
										))}
								</TextField> */}
							</DialogContent>
							<DialogActions style={{ padding: "14px" }}>
								<Button
									style={{
										backgroundColor: "#00b9f5",
										color: "#fff"
									}}
									variant="contained"
									onClick={handleClose}
								>
									Cancel
								</Button>
							</DialogActions>
						</Dialog>
					</div>

					{deleteOwnerWalletArray.status == "success" && (
						<div>
							<Dialog open={notificationOpen} onClose={handleNoticationClose}>
								<DialogContent
									className="text-center"
									style={{ backgroundColor: "#00b9f51c" }}
								>
									<img src={success} alt="" width="100px" className="my-2" />
								</DialogContent>
								<DialogContent>
									<h4
										style={{
											margin: "0",
											textAlign: "center",
											fontSize: "15px"
										}}
									>
										{deleteOwnerWalletArray.description}
									</h4>
								</DialogContent>
								<DialogActions style={{ justifyContent: "center" }}>
									<Button
										style={{
											margin: "10px 0",
											backgroundColor: "#00b9f5",
											color: "white"
										}}
										variant="contained"
										onClick={handleNoticationClose}
									>
										Ok
									</Button>
								</DialogActions>
							</Dialog>
						</div>
					)}

					{deleteOwnerWalletArray.status == "failed" && (
						<div>
							<Dialog open={notificationOpen} onClose={handleNoticationClose}>
								<DialogContent
									className="text-center"
									style={{ backgroundColor: "#00b9f51c" }}
								>
									<img src={failed} alt="" width="100px" className="my-2" />
								</DialogContent>
								<DialogContent>
									<h4
										style={{
											margin: "0",
											textAlign: "center",
											fontSize: "15px"
										}}
									>
										{deleteOwnerWalletArray.description}
									</h4>
								</DialogContent>
								<DialogActions style={{ justifyContent: "center" }}>
									<Button
										style={{
											margin: "10px 0",
											backgroundColor: "#00b9f5",
											color: "white"
										}}
										variant="contained"
										onClick={handleNoticationClose}
									>
										Ok
									</Button>
								</DialogActions>
							</Dialog>
						</div>
					)}
				</>
			</Layout>

			{updateCreateWalletResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateCreateWalletResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateCreateWalletResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateCreateWalletResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default AdminCreateWalletOwner;
